package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_03_17_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-03-17")
@Composable
public fun Log_2023_03_17(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Ankhegs Defeated",
        ogTitle = "Ankhegs Defeated",
        date = LocalDate(2_023, 3, 17),
        ogDescription = "The heroes emerge victorious against the Ankhegs, though Falorn is left disappointed by the lack of gold.",
        ogImage = "ai/2023-03-17.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-18", dateString = "Newgrowth 18")
        Log_2023_03_17_Day_1()
    }
}
